import videojs from 'video.js';
import 'videojs-contrib-eme';
import 'videojs-markers';

import Simplestream from './simplestream/plugin';
import vttThumbnails from './thumbnails/plugin';

import AwsMediaTailor from './ads/aws/plugin'; 
import Freewheel from './ads/freewheel/plugin'; 
import GoogleIma from './ads/google/plugin'; 
import GoogleVideoStitcher from './ads/google-video-stitcher/plugin'; 

import 'video.js/dist/video-js.css';
import 'videojs-markers/dist/videojs.markers.css';

window.HELP_IMPROVE_VIDEOJS = false;

export default class player {
    constructor(id, plugins) {

        this.plugins = plugins;

        // Load 3rd-party libraries
        if(this.plugins.includes('youbora')) {
            console.log('Include Youbora');
            this.importer.url('https://smartplugin.youbora.com/v6/js/adapters/videojs/6.7.7/sp.min.js').then(() => {
                youbora.Log.logLevel = youbora.Log.Level.DEBUG;
            }).catch(error => console.error('Could Not Load Youbora'));
        }

        this.container = document.getElementById(id);
        this.container.classList.add('simplestream');

        // Create player container
        const player = document.createElement('div');
        player.classList.add('simplestream-player');
        this.container.appendChild(player);

        // Create <video-js>
        const video = document.createElement('video-js');
        video.setAttribute('playsinline', null); 
        video.classList.add('video-js', 'vjs-cosmos', 'vjs-16-9', 'vjs-big-play-centered', 'vjs-show-big-play-button-on-pause');
        player.appendChild(video);

        this.player = videojs(video, {
            autoplay: false,
            controls: true,
            preload: 'auto',
            plugins: {
                Simplestream: true,
            }
        });

        this.player.on('simplestream-ready', (event, options) => {
            this.ready(options);
        });

    }

    ready(options) {

        // Thumbnail Preview
        if(options.streamsApiResponse.thumbnail_previews) {
            this.player.vttThumbnails({
                src: options.streamsApiResponse.thumbnail_previews.vtt
            });
        }

        // AWS Media Tailor
        if(options.streamsApiResponse.ads 
            && options.streamsApiResponse.ads.type == 'ssai' 
            && options.streamsApiResponse.ads.provider == 'media-tailor') {

            this.player.src({
                src: options.streamsApiResponse.stream,
                type: 'application/vnd.apple.mpegurl',
                ads: options.streamsApiResponse.ads,
            });

            this.player.AwsMediaTailor();

        // Google Video Stitcher
        } else if(options.streamsApiResponse.ads 
            && options.streamsApiResponse.ads.type == 'ssai' 
            && options.streamsApiResponse.ads.provider == 'google-video-stitcher') {

            this.player.src({
                src: options.streamsApiResponse.stream,
                type: 'application/vnd.apple.mpegurl',
            });

            this.player.GoogleVideoStitcher();

        // Google IMA
        } else if(options.streamsApiResponse.ads 
            && options.streamsApiResponse.ads.provider == 'google') {

            this.player.src({
                src: options.streamsApiResponse.stream,
                type: 'application/vnd.apple.mpegurl',
            });

            this.player.ima({
                adTagUrl: options.streamsApiResponse.ads.vast
            });

        // Google IMA with 3rd-party preroll and/or midroll VAST tags
        } else if(options.streamsApiResponse.ads 
            && options.streamsApiResponse.ads.preroll_vast) {

            this.player.src({
                src: options.streamsApiResponse.stream,
                type: 'application/vnd.apple.mpegurl',
            });

            this.player.GoogleIma(options.streamsApiResponse.ads);

        // DRM - Widevine
        } else if(options.streamsApiResponse.drm 
            && options.streamsApiResponse.drm.widevine) {

            this.player.Simplestream().debug('Google Widevine DRM');

            this.player.eme();
            
            this.player.src({
                src: options.streamsApiResponse.drm.widevine.stream,
                type: 'application/dash+xml',
                keySystems: {
                    'com.widevine.alpha': {
                        url: options.streamsApiResponse.drm.widevine.licenseAcquisitionUrl,
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_CRYPTO'
                    }
                }
            });

        // DRM - Fairplay
        } else if(options.streamsApiResponse.drm 
            && options.streamsApiResponse.drm.fairplay) {

            this.player.Simplestream().debug('Apple Fairplay DRM');

            return this.errorScreen('Fairplay DRM not yet implemented.');

        // HLS
        } else {

            this.player.Simplestream().debug('HLS Stream');

            this.player.src({
                src: options.streamsApiResponse.stream,
                type: 'application/vnd.apple.mpegurl'
            });

        }

        this.continueWatching();

        this.npaw(options.analyticsApiResponse);

        //this.events();

    }

    continueWatching() {
        // Not yet implemented
    }

    npaw(options) {
        if (typeof youbora.adapters.Videojs != "undefined") {
            if(this.plugins.includes('youbora')) {
                console.log('NPAW Player Analytics');
                window.plugin = new youbora.Plugin({
                    'accountCode': 'simplestreamdev',
                });
                plugin.setOptions(options);
                plugin.setAdapter(new youbora.adapters.Videojs(this.player));
            } else {
                console.log('NPAW Page Analytics');
                npawPlugin.registerAdapterFromClass(this.player, NpawPluginAdapters.video.Videojs);
            }
        } else {
            console.error('Youbora Adapter Not Loaded');
        }
    }

    events() {

        const EVENTS = [

            // HTMLMediaElement events
            'abort',
            'canplay',
            'canplaythrough',
            'durationchange',
            'emptied',
            'ended',
            'error',
            'loadeddata',
            'loadedmetadata',
            'loadstart',
            'pause',
            'play',
            'playing',
            'progress',
            'ratechange',
            'seeked',
            'seeking',
            'stalled',
            'suspend',
            'timeupdate',
            'volumechange',
            'waiting',
        
            // HTMLVideoElement events
            'enterpictureinpicture',
            'leavepictureinpicture',
        
            // Element events
            'fullscreenchange',
            'resize',
        
            // video.js events
            'audioonlymodechange',
            'audiopostermodechange',
            'controlsdisabled',
            'controlsenabled',
            'debugon',
            'debugoff',
            'disablepictureinpicturechanged',
            'dispose',
            'enterFullWindow',
            'error',
            'exitFullWindow',
            'firstplay',
            'fullscreenerror',
            'languagechange',
            'loadedmetadata',
            'loadstart',
            'playerreset',
            'playerresize',
            'posterchange',
            'ready',
            'textdata',
            'useractive',
            'userinactive',
            'usingcustomcontrols',
            'usingnativecontrols',
        ];

        EVENTS.forEach((event) => {
            this.player.on(event, function(event) {
                videojs.log(event);
            });
        });

    }

    errorScreen(msg) {

        videojs(video).dispose();

        const errorScreen = document.createElement('div');
        errorScreen.classList.add('error');
	    errorScreen.innerHTML = '<p>' +
            '<img src="data:image/svg+xml;utf8;base64,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" />' +
        '</p>' +
        '<p>Error</p>' +
        '<p>' + msg + '</p>';

        this.ssmp.getElementsByClassName('player')[0].appendChild(errorScreen);

    }

    dispose() {
        this.player.dispose();
    }

    importer = {
        url: (url) => {
            return new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = url;
                script.addEventListener('load', () => resolve(script), false);
                script.addEventListener('error', () => reject(script), false);
                document.body.appendChild(script);
            });
        },
        urls: (urls) => {
            return Promise.all(urls.map(importer.url));
        }
    };
}